/**
 * File main.js
 * 
 * Main JS file for WildRivers Underscores theme
 *
 * Will be compiled into js/main.js
 *
 * @package wildrivers
 */

import { mainNavigation } from './modules/main-navigation';
import { gform } from './modules/gform';
import { dialog } from './modules/dialog';
import { loadMore, categoryFilter } from './modules/post-archive';
import { anchorNav } from './modules/anchor-nav';
import { linkedMedia } from './modules/linked-media';
import { verticalSlides } from './modules/vertical-slides';
import { share } from './modules/share';
import { slideshow } from './modules/slideshow';
import { itemsLoadmore } from './modules/items-loadmore';
import { itemsFilter } from './modules/items-filter';
import { addToCalendar } from './modules/add-to-calendar';

// run all functions on page load.
document.addEventListener( 'DOMContentLoaded', function () {
	mainNavigation();
	gform();

	const $ = window.jQuery;
	if ( $ ) {
		$( document ).on( 'gform_post_render', function ( event, formId ) {
			const wrapper = document.getElementById( 'gform_wrapper_' + formId );
			if ( wrapper ) {
				gform( wrapper );
			} else {
				gform();
			}
		} );
	}

	dialog();
	loadMore();
	categoryFilter();
	anchorNav();
	linkedMedia();
	verticalSlides();
	slideshow();
	share();
	addToCalendar();
	itemsLoadmore();
	itemsFilter();
} );
